import { PropsWithChildren } from 'react';

const Page = (props: PropsWithChildren<{}>) => (
	<div className="py-8 px-10 w-full">{props.children}</div>
);

export default Page;
